import React, { useState, useEffect } from 'react'
import Header from "../../components/layouts/Header"
import Footer from "../../components/layouts/Footer"
import Swal from "sweetalert2";
import FormLoading from "../../components/loadding/FormLoading";

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();

        setError("");

        // validate basic
        if (!email || !password || !passwordConfirm) {
            setError("Vui lòng nhập đầy đủ thông tin");
            return;
        }

        if (password.length < 6) {
            setError("Mật khẩu phải có ít nhất 6 ký tự");
            return;
        }

        if (password !== passwordConfirm) {
            setError("Mật khẩu xác nhận không khớp");
            return;
        }

        try {
            setLoading(true);

            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/customer/re-password`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        email,
                        password,
                        password_confirmation: passwordConfirm,
                    }),
                }
            );

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || "Reset password failed");
            }

            setLoading(false);

            await Swal.fire({
                icon: "success",
                title: "Thành công",
                text: "Cập nhật mật khẩu thành công!",
                timer: 1500,
                showConfirmButton: false,
            });
            setEmail("");
            setPassword("");
            setPasswordConfirm("");
        } catch (err: any) {
            setError("Có lỗi xảy ra");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />

            <div className="text-4xl font-bold text-center pt-24">Đổi mật khẩu</div>

            <div className="max-w-[104rem] w-[96%] mx-auto pb-[8rem] mt-12">
                <form onSubmit={handleResetPassword} className="flex flex-col gap-6 max-w-[40rem] m-auto">

                    <input
                        type="email"
                        placeholder="Email"
                        className="border rounded-xl px-6 py-4 text-2xl"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <input
                        type="password"
                        placeholder="Mật khẩu mới"
                        className="border rounded-xl px-6 py-4 text-2xl"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <input
                        type="password"
                        placeholder="Xác nhận mật khẩu"
                        className="border rounded-xl px-6 py-4 text-2xl"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                    />

                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-dark font-semibold max-w-[25rem] mx-auto mt-4"
                    >
                        Đổi mật khẩu
                    </button>

                    {error && (
                        <p className="text-red-500 text-lg">*{error}</p>
                    )}
                </form>
            </div>

            {loading && (
                <FormLoading loading={loading} />
            )}

            <Footer />
        </>
    );
};

export default ResetPassword;